import { useNavigate } from 'react-router-dom';
import classes from './Tabs.module.css'

const tabs = [
    {
        name: "Trading",
        link: "/trading"
    },
    {
        name: "Payout Pool",
        link: "payout-pool"
    },
    {
        name: "Profile",
        link: "profile"
    }
]

const Tabs = () => {
    const navigate = useNavigate();
    return(
        <div className={`${classes.wrapper} mt-5`}>
        <div className='d-flex gap-3'> {tabs.map((item, i) => (<div key={i} onClick={() => navigate(item.link)} className={`${classes.tabContatiner} ${window.location.pathname.includes(item.link) ? classes.activeTab : ""}`} role='button'>{item.name}</div>))}</div>
        </div>
    )
}

export default Tabs